"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
function InquiryFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-primary/20 border border-primary/30 rounded-[var(--radius-sm)]">
        <p className="text-foreground-dark text-lg font-medium">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6 border-primary/40 hover:bg-primary/10 text-foreground-dark">
          Submit Another Inquiry
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-index={0}>
        <FormField control={control} name="full_name" rules={{
        required: "Full Name is required",
        minLength: {
          value: 2,
          message: "Name must be at least 2 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Doe" {...field} className="bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Company / Organization</FormLabel>
              <FormControl>
                <Input placeholder="West Indian Digital" {...field} className="bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-index={1}>
        <FormField control={control} name="email" rules={{
        required: "Email Address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane@example.com" {...field} className="bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+1 (555) 123-4567" {...field} className="bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="mt-6" data-index={2}>
        <FormField control={control} name="subject" rules={{
        required: "Subject is required",
        minLength: {
          value: 3,
          message: "Subject must be at least 3 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Subject</FormLabel>
              <FormControl>
                <Input placeholder="e.g., Partnership Opportunity" {...field} className="bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="mt-6" data-index={3}>
        <FormField control={control} name="message" rules={{
        required: "Message is required",
        minLength: {
          value: 10,
          message: "Message must be at least 10 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground-dark font-medium">Message</FormLabel>
              <FormControl>
                <textarea placeholder="Please describe your inquiry in detail..." rows={5} {...field} className="w-full bg-transparent border-b-2 border-t-0 border-x-0 border-border/40 rounded-none px-0 py-2 focus-visible:border-primary focus-visible:ring-0 transition-all duration-[var(--duration-medium)] focus-visible:shadow-[0_2px_0_0] focus-visible:shadow-primary text-foreground-dark placeholder:text-muted-foreground/60 outline-none resize-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <div className="mt-6 p-4 bg-red-500/20 border border-red-500/40 rounded-[var(--radius-sm)]">
          <p className="text-red-300">{submitError}</p>
        </div>}

      <div className="mt-8">
        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px] bg-accent text-foreground-accent hover:bg-accent-hover hover:scale-[1.02] active:bg-accent-active active:scale-[0.98] transition-all duration-[var(--duration-fast)] font-semibold tracking-wide px-8 py-3 shadow-medium">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Submitting...
            </> : 'Submit Inquiry'}
        </Button>
      </div>
    </Form>;
}
export default function InquiryForm() {
  return <section id="inquiry-form" className="dark bg-background text-foreground relative min-h-[30vh] py-16 px-4 md:px-8 lg:px-16 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300ff88' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      transform: 'translateY(calc(var(--scroll-y, 0) * 0.05px))'
    }} />

      <div className="relative z-10 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          
          <p className="text-muted-foreground/80 text-lg max-w-2xl mx-auto">
            For partnership inquiries, investor relations, or operational questions, please complete the form below. Our team will respond within 48 business hours.
          </p>
        </div>

        <FormProvider className="bg-dark-section/80 backdrop-blur-sm border border-primary/10 rounded-[var(--radius-sm)] p-8 md:p-12 shadow-strong" formId="inquiry_form_contact" sectionName="inquiry-form" defaultValues={{
        full_name: "",
        company_name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      }} validationRules={{
        full_name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        subject: {
          required: true,
          minLength: 3
        },
        message: {
          required: true,
          minLength: 10
        }
      }} submitText="Submit Inquiry" successMessage="Thank you for your inquiry. We will review your message and respond within 48 business hours." errorMessage="We encountered an issue submitting your inquiry. Please verify your information and try again.">
          <InquiryFormContent />
        </FormProvider>
      </div>
    </section>;
}